import(/* webpackMode: "eager", webpackExports: ["ExpandableCard"] */ "/vercel/path0/frontend/src/components/ui/expandable-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FirstRunWelcome"] */ "/vercel/path0/frontend/src/components/ui/first-run-welcome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroStats"] */ "/vercel/path0/frontend/src/components/ui/home-stats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextWindowBanner"] */ "/vercel/path0/frontend/src/components/ui/next-window-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteNav"] */ "/vercel/path0/frontend/src/components/ui/site-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemePicker"] */ "/vercel/path0/frontend/src/components/ui/theme-picker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
